import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import {
    COLOR_ORANGE_PRIMARY,
    COLOR_WHITE,
    COLOR_SECONDARY,
    COLOR_OPTION_BUTTON_BG,
    COLOR_DARK,
} from '../../../constants/color.ts';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

interface ActionButtonProps {
    buttonText: string | null;
    styleProps?: {};
    href?: string;
    endAdornment?: React.ReactNode;
    onClick? : () => void;
}
const StyledActionButton = styled(Button)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '6.24px ',
    border: COLOR_ORANGE_PRIMARY,
    background: COLOR_ORANGE_PRIMARY,
    color: COLOR_WHITE,
    textTransform: 'none',
    fontSize: '16px ',
    fontStyle: 'normal',
    fontFamily: 'Poppins',
    fontWeight: 500,
    letterSpacing: '1px',
    lineHeight: '125%',
    padding: '6px 24px',
    width: 'fit-content',
    gap: '24px',
    transition: 'all 0.3s ease-in-out',
    '&:hover': {
        backgroundColor: COLOR_ORANGE_PRIMARY,
        border: COLOR_ORANGE_PRIMARY,
    },
    [theme.breakpoints.down('md')]: {
        fontSize: '16px',
        padding: '6px 24px',
    },
}));

export const CustomActionButton: React.FC<ActionButtonProps> = ({ buttonText, styleProps,href, endAdornment, ...props }) => {
    return (
        <StyledActionButton sx={{ ...styleProps }} {...props} disableRipple href={href} variant="contained"
        endIcon={endAdornment}>
            {buttonText}
        </StyledActionButton>
    );
};
